// extracted by mini-css-extract-plugin
export default {"page-shop":"shops_page-shop__Qej4B","title":"shops_title__lEYWZ","ellipsis":"shops_ellipsis__64eir"};